import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import MDBox from 'components/MDBox';
import MDInput from 'components/MDInput';
import React, { useState } from 'react'
import { IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import PropTypes from 'prop-types';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';

export default function PasswordResetModel({ open, onClose }) {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const bearerToken = localStorage.getItem('token');
    const [newPassword, setNewPassword] = useState('');
    const [oldPassword, setOldPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const handleClose = () => {
        onClose();
        setNewPassword('');
        setOldPassword('');
        setShowPassword(false);
    };

    const handleResetPassword = async () => {

        if (!bearerToken) return;

        axios.patch(`${apiUrl}auth-service/auth/change-password`, {
            password: oldPassword, newPassword: newPassword
        }, {
            headers: { Authorization: `Bearer ${bearerToken}` }
        })
            .then(({ data }) => {
                if (data?.success) {
                    alert(data?.message || 'Password Has Been Changed!');
                }
                else throw new Error("Unable to change passsword");
            })
            .catch(error => alert(error.response?.data?.message || error.message));
        handleClose();

    };

    const togglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    return (
        <>
            <Dialog onClose={handleClose} open={open} maxWidth="sm" fullWidth>
                <DialogTitle>Reset Password</DialogTitle>
                <DialogContent>
                    <MDBox pt={4} pb={3} px={3} component="form" role="form">
                        <MDBox mb={1}>
                            <MDInput
                                type={showPassword ? 'text' : 'password'}
                                label="Old Password"
                                fullWidth
                                value={oldPassword}
                                onChange={(e) => setOldPassword(e.target.value)}
                                InputProps={{
                                    endAdornment: (
                                        <IconButton onClick={togglePasswordVisibility}>
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    ),
                                }}
                            />
                        </MDBox>
                        <MDBox mb={4}>
                            <MDInput
                                type={showPassword ? 'text' : 'password'}
                                label="New Password"
                                fullWidth
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                InputProps={{
                                    endAdornment: (
                                        <IconButton onClick={togglePasswordVisibility}>
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    ),
                                }}
                            />
                        </MDBox>
                    </MDBox>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="secondary">Cancel</Button>
                    <Button onClick={handleResetPassword} color="primary">Reset</Button>
                </DialogActions>
            </Dialog>
            <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </>
    );
}

PasswordResetModel.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};
